export default __webpack_public_path__ + "static/media/checkmark-done-circle.fb0b1dba.svg";